import { Box, Portal } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./account.section.css";
import { IUserWallet } from "../../store/models/user/typing/user.interface";
import { useTranslation } from "react-i18next";
import personal_account from "../../assets/icons/menu/personal_account.svg";
import bonuses from "../../assets/icons/menu/bonuses.svg";
import favorites from "../../assets/icons/menu/heart.svg";
import exit from "../../assets/icons/menu/exit.svg";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks/store.hooks";
import { logout } from "../../store/models/auth/auth.thunk";
import { googleLogout } from "@react-oauth/google";

interface IAccountSectionProps {
  active: boolean;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
  activeBonus: boolean;
  wallet: IUserWallet;
}
export const AccountSection = ({
  active,
  setActive,
  activeBonus,
  wallet,
}: IAccountSectionProps) => {
  const { t } = useTranslation();
  const navigator = useNavigate();
  const dispatch = useAppDispatch();
  return (
    <Portal>
      <Box
        className={active ? "account-section active" : "account-section"}
        onClick={() => {
          setActive(!active);
        }}
      >
        <Box
          className="account-section__container"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Box className="account-section__balance">
            <Box className="account-section__balance-item">
              <Box className="account-section__balance-item-title">
                {t("main.profile.menu.mainbalance")}
              </Box>
              <Box className="account-section__balance-item-sum">
                {`${(+wallet.balance.main_balance)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${
                  wallet.currency.name
                }`}
              </Box>
            </Box>
            <Box className="account-section__balance-item">
              <Box className="account-section__balance-item-title">
                {t("main.profile.menu.bonusbalance")}
              </Box>
              <Box className="account-section__balance-item-sum">
                {`${(+wallet.balance.bonus_balance)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${
                  wallet.currency.name
                }`}
              </Box>
            </Box>
            <Box className="account-section__balance-item">
              <Box className="account-section__balance-item-title">
                {t("main.profile.menu.reservedbalance")}
              </Box>
              <Box className="account-section__balance-item-sum">
                {`${(+wallet.balance.reserved_balance)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${
                  wallet.currency.name
                }`}
              </Box>
            </Box>
          </Box>
          <Box className="account-section__footer">
            <Box className="account-section__buttons">
              <button
                onClick={() => {
                  setActive(false);
                  navigator("/profile/personal-info");
                }}
              >
                <img src={personal_account} alt="Personal Account" />
              </button>
              <button
                className={activeBonus ? "with-bonus" : ""}
                onClick={() => {
                  setActive(false);
                  navigator("/profile/bonuses");
                }}
              >
                <img src={bonuses} alt="My bonuses" />
              </button>
              <button
                onClick={() => {
                  setActive(false);
                  navigator("/lobby/slots?favorite=true");
                }}
              >
                <img src={favorites} alt="Favorites" />
              </button>
            </Box>
            <Box className="account-section__logout">
              <button
                onClick={async () => {
                  setActive(false);
                  await dispatch(logout());
                  await googleLogout();
                  navigator("/");
                }}
              >
                <img src={exit} alt="Exit" />
              </button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Portal>
  );
};
